<template>
  <div>
    <!-- [ Header form ] start -->
    <el-row  :gutter="20" type="flex" justify="center" class="">
      <el-col :span="24">

        <div class="header">
          <!-- <div class="text">All-in-One cloud software solution for Accountants!</div> -->
          <!-- <router-link to="/"> -->
            <img src="@/assets/img/logo.png" alt="Totalflow" width="230">
          <!-- </router-link> -->
          <div class="description" v-html="description"></div>
          <div class="icon">
            <font-awesome-icon :icon="icon" size="lg"/>
          </div>
        </div>

      </el-col>
    </el-row>
    <!-- [ Header form ] end -->

  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: 'Be Amazed!'
    },
    icon: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  // max-width: 350px;
  // margin-top: 50px;
  // text-align: center;
  .text {
    margin-bottom: 10px;
  }
  img {
    margin-bottom: 10px;
  }
  .description {
    color: #4D4C4C;
  }
  .icon {
    color: #409EFF;
    padding-top: 20px;
  }
}
</style>
